<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_5"></a><a id="acknowledgments"></a>Acknowledgments</h2>
<p class="noindent">As always, I’d like to acknowledge the hard work and good advice of my editor, David Hartwell, as well as Denis Wong at Tor Books; my agent Donald Maass for having the good grace to run with this project when I unexpectedly dropped it in his lap; and of course, Janice and Paige for their patience during my extended periods of impractical musing and daydreaming.<a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?76aba1c8